import Carousel from './Carousel';

import { carouselData } from './data/carouselData';

const GiftBoxes = () => {
  return (
    <div className='wp-block-group cf--color-heading-cta is-layout-flow wp-block-group-is-layout-flow cf-gift-boxes-container'>
      <div className=' cf-gift-boxes-text'>
        <h2 className='wp-block-heading'>Gift Boxes</h2>
        <p className='cf-gift-boxes'>
          Treat your friends, colleagues, or loved ones to a unique gift box
          with combinations of our award-winning ciders and apple brandy. Our
          ciders and apple brandy are truly one-of-a-kind, reflecting the
          essence of our local orchard and can be shipped anywhere. Give the
          gift of a world-class experience from your own backyard with The Cider
          Farm.
          <div
            className='wp-block-button is-style-outline'
            style={{ marginTop: '16px' }}
          >
            <a
              className='wp-block-button__link cf-gift-boxes__button'
              href='https://theciderfarm.com/shop'
            >
              Shop now!
            </a>
          </div>
        </p>
      </div>
      <div className='carousel-container'>
        <Carousel data={carouselData} />
      </div>
    </div>
  );
};

export default GiftBoxes;
